export const COMPENSATION_LACK_STOCK = '缺货退款单';
export const COMPENSATION_CHECK = '质检退款单';
export const COMPENSATION_AFTER_SALE = '售后退款单';

export const COMPENSATION_TYPE_OPTIONS = [
    { value: '品质', label: '品质' },
    { value: '数量', label: '数量' },
    { value: '品种', label: '品种' },
    { value: '其他', label: '其他' },
    // { value: '客户投诉', label: '客户投诉' },
    // { value: '苗场违约', label: '苗场违约' }
    { value: '物流', label: '物流' }
];

export const COMPENSATION_PERSON_OPTIONS = [
    { value: 'customer', label: '客户' },
    { value: 'seedfarm', label: '苗场' },
    { value: 'station', label: '转运站' },
    { value: 'manager', label: '客户经理' }];


//退款单状态
export const COMPENSATION_STATUS_NORMAL = '正常';
export const COMPENSATION_STATUS_REVOKE = '撤销';

export const getStatusOptions = () => {
    const status = [
        COMPENSATION_STATUS_NORMAL,
        COMPENSATION_STATUS_REVOKE
    ];

    return status.map(s => {
        return { key: s, value: s };
    });
};

//审核状态
export const AUDIT = 0;
export const APPROVAL_YES = 1;
export const APPROVAL_No = 2;

export const approveStatusFormat = val => {
    switch (val) {
        case AUDIT:
            return '待审核';
        case APPROVAL_YES:
            return '审核通过';
        case APPROVAL_No:
		    return '审核不通过';
    }

    return '';
};

export const getApproveStatusOptions = () => {
    return [
        { value: AUDIT, key: '待审核' },
        { value: APPROVAL_YES, key: '审核通过' },
        { value: APPROVAL_No, key: '审核不通过' }
    ];
};
